/**
 * 描述：编辑租户
 * 日期：2017-11-7
 * 作者：liujinming
 */
"use strict";
angular.module("broadcastStatusModule", [])
    .controller("broadcastStatusCtrl", ["$scope", "$rootScope", "$modalInstance", "item", "localStorageService", "$sce", "trsHttpService", "modalDialog", "$timeout", "$compile", "commandService", "$q", "$validation", "$element",
        function($scope, $rootScope, $modalInstance, item, localStorageService, $sce, trsHttpService, modalDialog, $timeout, $compile, commandService, $q, $validation, $element) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    broadCastStatus: [
                        { name: '联系中', Status: '1' },
                        { name: '采编中', Status: '2' },
                        { name: '已审核', Status: '3' },
                        { name: '已发布', Status: '4' },
                    ],
                    channelsDataPubWayTB: [],
                    metaTypeInfo:item.metaTypeInfo[0],
                };
                $scope.data = {
                    selectedArray: item.records.map(function(value, index) {
                        return {
                            Type: value.TYPE,
                            Status: value.STATUS
                        }
                    })
                };
            }
            //选择制播状态
            $scope.chooseBroadCast = function(item, items) {
                var checkInfo = $scope.isChecked(item, items);
                if (checkInfo.flag) {
                    $scope.data.selectedArray.splice(checkInfo.index, 1);
                    return;
                }
                var obj = {
                    Status: item.Status,
                    Type: items.Type
                };
                for (var i in $scope.data.selectedArray) {
                    var elem = $scope.data.selectedArray[i];
                    if (elem.Type == items.Type) {
                        $scope.data.selectedArray[i] = obj;
                        return;
                    }
                }
                $scope.data.selectedArray.push(obj);
            };
            /**
             * [isChecked description] 复选框是否选中
             * @param {object} [item] [description] 状态信息
             * @param {object} [items] [description] 分类信息
             * @return {Boolean} [description]
             */
            $scope.isChecked = function(item, items) {
                for (var i in $scope.data.selectedArray) {
                    var elem = $scope.data.selectedArray[i];
                    if (elem.Status == item.Status && elem.Type == items.Type)
                        return { flag: true, index: i };
                }
                return { flag: false };
            };
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
               var dataArray=[];
                for(var i in $scope.status.metaTypeInfo){
                    if(i=='METATYPEBYTV'||i=='METATYPEBYTVOTHER'){
                        dataArray.push({name:'电视台',Type:1});
                    }
                    if(i=='METATYPEBYBROADCAST'||i=='METATYPEBYBROADCASTOTHER'){
                        dataArray.push({name:'广播',Type:2});
                    }
                }
                $scope.status.channelsDataPubWayTB=dataArray;
            }
            /**
             * [confirm description] 提交
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                var records = JSON.stringify(angular.copy($scope.data.selectedArray));
                commandService.newInvoke('saveRecord', { ReportId: item.ReportId, Records: records }).then(function(data) {
                    if (data.ISSUCCESS == 'true') {
                        modalDialog.alertType('设置成功', '', 'success', false, function() {
                            $modalInstance.close();
                        });
                    } else {
                        modalDialog.alertType('设置失败', '', 'error', "confirm", function() {
                            $modalInstance.close();
                        });
                    }
                });
            };
            /**
             * [close description] 关闭弹窗
             * @return {[type]} [description]
             */
            $scope.close = function() {
                $modalInstance.dismiss();
            };
        }
    ]);